var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BulletedList",attrs:{"id":_vm.BlocksIndex}},[_c('BaseListBlock',{attrs:{"value":_vm.value,"BlocksIndex":_vm.BlocksIndex,"placeholder":"输入列表内容"}},[_c('span',{staticClass:"left-Symbol"},[_vm._v("·")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }